import { MailType } from "./mailcredit";

export type OneToTwentyNine =
  | 1 | 2 | 3 | 4 | 5 | 6 | 7
  | 8 | 9 | 10 | 11 | 12 | 13
  | 14 | 15 | 16 | 17 | 18 | 19
  | 20 | 21 | 22 | 23 | 24 | 25
  | 26 | 27 | 28 ;

export type MonthDate = {
  day: OneToTwentyNine;
  isLastDay: boolean;
};

export enum ReminderScheduleType {
  Daily = "daily",
  Weekly = "weekly",
  Monthly = "monthly",
  Custom = "custom",
}

export enum WeekDays {
  Monday = "monday",
  Tuesday = "tuesday",
  Wednesday = "wednesday",
  Thursday = "thursday",
  Friday = "friday",
  Saturday = "saturday",
  Sunday = "sunday",
}

export type ReminderSchedule = {
  _id?: string;
  reminderScheduleType: ReminderScheduleType;
  reminderWeekDay: WeekDays;
  reminderMonthDate: MonthDate;
  selectedDates: Date[];
  mailType: MailType;
  guests?: string[];
  sendToAll?: boolean;
};

export type Reminder = {
  _id: string;
  reminderScheduleType: ReminderScheduleType;
  executionTimeMap: Record<string, Date>;
  reminderWeekDay: WeekDays;
  reminderMonthDate: MonthDate;
  sendToAll: boolean;
  accountID: string;
  wedddingID: string;
  mailType: MailType;
  guests: string[];
  createdAt: Date;
  updatedAt: Date;
};
